export default __webpack_public_path__ + "static/media/icon_ui_generate.b18a0fec.png";